<n-data-table
    #dt
    [columnDefs]="tableColumnDefs"
    [config]="tableConfig"
    [data]="data"
    [loading]="loading"
    id="file-system-dtree-table"
    style="height: calc(100% - 55px)">
    <!-- 共享类型 -->
        <ng-template [meta]="{field: 'shareTypes', pos: 'right'}" [nTemplate] let-data="rowData" let-value="value">
            <div *ngIf="value" [nTextTips]="shareInfo">
                <ng-container [ngTemplateOutlet]="shareInfo"></ng-container>
            </div>
            <ng-template #shareInfo>
                <div class="icon-list">
                    <button *ngIf="value.NFS" [border]="false" [nTooltip]="i18n.get('common.nfsShare_lab')" icon="app-icon-nfs"
                        nButton nTooltipPlacement="top">
                    </button>
                    <button *ngIf="value.CIFS" [border]="false" [nTooltip]="i18n.get('common.cifsShare_lab')" icon="app-icon-cifs"
                        nButton nTooltipPlacement="top">
                    </button>
                </div>
            </ng-template>
        </ng-template>
    <!-- 配额 -->
        <ng-template [meta]="{field: 'quotaCfgCount'}"
            [nTemplate]
            let-data="rowData"
            let-value="value">
            <div *ngIf="value > 0"
                [nTextTips]="quotaInfo">
                <ng-container [ngTemplateOutlet]="quotaInfo"></ng-container>
            </div>
            <ng-template #quotaInfo>
                <div class="icon-list">
                    <button [border]="false"
                        [nTooltip]="i18n.get('common.quota_lab')"
                        icon="app-icon-quota"
                        nButton nTooltipPlacement="top">
                    </button>
                </div>
            </ng-template>
        </ng-template>
</n-data-table>
